import Css from "./Customer.module.css";
import {
    Row,
    Col,
    Form,
    Button,
    Tab,
    Table,
    InputGroup,
} from "react-bootstrap";

export default function CustomerTax({ stepPage = 1, data = undefined, disabled = false }) {
    return (
        <div className={Css.Register_customer_layout + ' h-auto'}>
            <label className={Css.colorfont}>
                <h6>ที่อยู่ในการออกใบเสร็จ/ใบกำกับภาษี</h6>
            </label>
            <br />
            <Form.Group className={`mb-2 ${Css.body2}`}>
                <Form.Label className={Css.colorlabel} >ชื่อบริษัท</Form.Label>
                {
                    disabled === true &&
                    <Col>
                        <Form.Text className="fs-6">{data?.payee_name}</Form.Text>
                    </Col>
                }
                {
                    disabled === false &&
                    <Form.Control placeholder="" name={"company"} type="text" value={data?.payee_name} />
                }

            </Form.Group>
            <Form.Group className={`mb-2 ${Css.body2}`}>
                <Form.Label className={Css.colorlabel}>ที่อยู่</Form.Label>
                {
                    disabled === true &&
                    <Col>
                        <Form.Text className="fs-6">{data?.payee_address}</Form.Text>
                    </Col>
                }
                {
                    disabled === false &&
                    <Form.Control placeholder="" name={"address"} type="text" value={data?.payee_address} />
                }

            </Form.Group>
            <Form.Group className={`mb-2 ${Css.body2}`}>
                <Form.Label className={Css.colorlabel}>หมายเลขโทรศัพท์</Form.Label>
                {
                    disabled === true &&
                    <Col>
                        <Form.Text className="fs-6">{data?.payee_tel}</Form.Text>
                    </Col>
                }
                {
                    disabled === false &&
                    <Form.Control placeholder="" name={"phonenumber"} type="text" value={data?.payee_tel} />
                }

            </Form.Group>
            <div>
                <Row className={`${Css.body2}`}>
                    <Col>
                        <Form.Group>
                            <Form.Label className={Css.colorlabel}>เลขประจำตัวผู้เสียภาษีอากร</Form.Label>
                            {
                                disabled === true &&
                                <Col>
                                    <Form.Text className="fs-6">{data?.payee_tax_id}</Form.Text>
                                </Col>
                            }
                            {
                                disabled === false &&
                                <Form.Control placeholder="" name={"tax"} type="text" value={data?.payee_tax_id} />
                            }

                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group>
                            <Form.Label className={Css.colorlabel}>สาขา/รหัสสาขา</Form.Label>
                            {
                                disabled === true &&
                                <Col>
                                    <Form.Text className="fs-6">{data?.payee_branch}</Form.Text>
                                </Col>
                            }
                            {
                                disabled === false &&
                                <Form.Control placeholder="" name={"branch"} type="text" value={data?.payee_branch} />
                            }
                        </Form.Group>
                    </Col>
                </Row>
            </div>
        </div>
    );
}